<template>
	<div class="tab_item detail_body">
		<div class="coll">
			<h2 class="title"><span>重量信息</span></h2>
			<div class="cons">
				<table class="tab_detail">
					<tr>
						<th>毛重</th><td>{{sdata.grossWeight}}</td>
						<th>净重</th><td>{{sdata.netWeight}}</td>
					</tr>
					<tr>
						<th>重量单位</th><td colspan="3">{{sdata.weightUnitDesc}}</td>
					</tr>
				</table>
			</div>
		</div>
		<div class="coll">
			<h2 class="title"><span>尺寸信息</span></h2>
			<div class="cons">
				<table class="tab_detail">
					<tr>
						<th>长度</th><td>{{sdata.length}}</td>
						<th>宽度</th><td>{{sdata.width}}</td>
					</tr>
					<tr>
						<th>高度</th><td>{{sdata.height}}</td>
						<th>尺寸单位</th><td>{{sdata.measureUnitDesc}}</td>
					</tr>
				</table>
			</div>
		</div>
		<div class="coll">
			<h2 class="title"><span>保质期</span></h2>
			<div class="cons">
				<table class="tab_detail">
					<tr>
						<th>最长保质期</th><td>{{sdata.maxShelfLife}}</td>
						<th>最小保质期</th><td>{{sdata.minShelfLife}}</td>
					</tr>
					<tr>
						<th>保质期的年月日</th><td colspan="3">{{sdata.shelfTerminalDate}}</td>
					</tr>
				</table>
			</div>
		</div>
				<!-- <div class="coll">
					<h2 class="title"><span>基础数据</span></h2>
					<div class="cons">
					</div>
				</div>
				<div class="coll">
					<h2 class="title"><span>基础数据</span></h2>
					<div class="cons">
					</div>
				</div> -->
	</div>

</template>

<script>
export default{
	props:{
		sdata:Object
	}
}
</script>

<style>
</style>
